<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml" xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <base-page-component :has-back="false" :has-nav="false" nav-title="引导页">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="bg-white m-auto">

        <div class="flex a-center h-60">
          <Button @click="groupManager.show = true" class="m-l-25 m-r-10" type="primary">分类管理
          </Button>
          <Button @click="createNewPage()" class="m-r-10" type="primary">新建商品</Button>

          <class-choose-widget :gutter="10" :srcType="11" @dataChange="onClassGroupChange" leftPlaceholder="商品分类"
                               rightPlaceholder="商品分组"
                               style="width: 300px;">

          </class-choose-widget>

          <Button class="m-l-15" type="primary"
                  v-clipboard:copy="objChange.linkurl"
                  v-clipboard:error="onError"
                  v-clipboard:success="copy">复制链接
          </Button>
          <Input class="m-l-15" placeholder="商品名称" style="width: 240px" v-model="title"/>
          <Button @click="onSearchClick" class="m-l-15">搜索</Button>
        </div>

        <div class="m-h-25 ">
          <Table :columns="columns" :data="dataList"
                 :height="tableHeight">

            <template v-slot:copy="{row,index}">
              <div class="flex a-center j-center">
                <div class="icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"
                     v-clipboard:copy="row.url"
                     v-clipboard:error="onError"
                     v-clipboard:success="copy"/>

              </div>
            </template>
            <template v-slot:status="{row,index}">
              <div class="flex a-center j-center">
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2"
                     style="background-color: #EEFFEF;color: #4CAF50;border-radius: 11px;"
                     v-if="row.isActive === 1">
                  已发布
                </div>
                <div class="p-h-10 fs-13 flex a-center j-center p-t-2"
                     style="background-color: #FFF3EB;color: red;border-radius: 11px;"
                     v-else>
                  未发布
                </div>
              </div>
            </template>


            <template v-slot:link="{row,index}">
              <div class="flex a-center j-center">
                {{ row.url }}

              </div>
            </template>

            <template v-slot:operation="{row,index}">
              <div class="flex j-between fs-12">
                <span @click="onPageRenovationClick(row)" class=""
                      style="cursor: pointer;color: #3B80FF">商品装修</span>
                <span @click="onGoodsCaseClick(row)" class=""
                      style="color:#3B80FF;cursor: pointer">案例</span>
                <span @click="onGoodsEdit(row)" class=""
                      style="color:#3B80FF;cursor: pointer">商品信息</span>
                <!--                <span @click="onShareSettingClick(row,index)" class=""-->
                <!--                      style="color:#3B80FF;cursor: pointer">分享设置</span>-->
                <span @click="onImageClick (row)" class=""
                      style="color:#3B80FF;cursor: pointer">二维码</span>
                <span @click="delPage(row,index)"
                      style="color:red ;cursor: pointer">删除</span>
                <span :style="{color:getStatus(row)}"
                      @click="changeStatus(row,index)"
                      style="cursor: pointer">{{ row.isActive === 1 ? '停用' : '发布' }}</span>
              </div>
            </template>
          </Table>
          <div style="padding: 10px 0; display: flex; justify-content: flex-end;">
            <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize" :page-size-opts="pageSizeOpts"
                  :show-total="true"
                  :total="tablePage.total" @on-change="onPageChange" @on-page-size-change="onPageSizeChange"
                  show-sizer></Page>
          </div>
        </div>
      </div>
    </div>


    <!--    重置名称弹框-->
    <Modal
        :closable="false"
        class="modal-setting"
        title=" "
        v-model="renameModal.show"
        width="400px"
    >
      <!--      class-name="vertical-center-modal"-->
      <p class="text-center" slot="header">
        <span>重置名称</span>
      </p>

      <div class="w-full flex j-center" slot="footer">
        <Button @click="renameModalCancel">取消</Button>
        <Button @click="renameModalOk" style="margin-left: 50px" type="primary">确定</Button>
      </div>
      <!--      <div style="width: 400px" class="flex j-center a-center m-b-20">-->
      <Input class=" m-b-10"
             style="width: 320px" v-model="renameModal.name"/>
      <!--      </div>-->

    </Modal>

    <!--    新建页面弹框-->
    <Modal
        :closable="false"
        @on-visible-change="onPageModalClose"
        class="modal-setting"
        class-name="vertical-center-modal"
        footer-hide
        v-model="createPageModal.show"
        width="400"
    >
      <!--      class-name="vertical-center-modal"-->
      <p class="text-center" slot="header">
        <span>{{ createPageModal.title }}</span>
      </p>
      <div class="w-full p-h-30">
        <span class="fs-14">商品名称</span>
        <Input class=" m-v-10" placeholder="商品名称" v-model="createPageModal.pageTitle"/>

        <class-vertical-choose-widget :objData="objData" direction="horizontal"
                                      ref="classchoose">
          <span class="fs-14 flex-s-0 m-r-10" slot="footer">商品分类</span>
          <span class="fs-14 flex-s-0 m-r-10" slot="groupTitle">商品分组</span>
        </class-vertical-choose-widget>

        <div class="w-full flex j-center m-v-30">
          <Button @click="createPageModalCancel" style="width: 110px">取消</Button>
          <Button @click="createPageModalOk" style="margin-left: 20px;width: 110px" type="primary">
            确定
          </Button>
        </div>
      </div>

    </Modal>

    <Modal
        :closable="false"
        class="modal-setting"
        class-name="vertical-center-modal"
        v-model="groupManager.show"
        width="640px"
    >
      <p class="text-center" slot="header">
        <span>{{ groupManager.title }}</span>
      </p>

      <div class="flex a-center j-center" style="width: 600px;height: 360px">
        <class-group-setting-widget :objInfo="objInfo"
                                    :srcType="11"
                                    class="w-full h-full">
        </class-group-setting-widget>
      </div>

    </Modal>

    <Modal
        @on-visible-change="onQrcodeModalClose"
        class-name="vertical-center-modal"
        footer-hide
        v-model="showModel"
        width="550">
      <p class="fz-14 color-33 margin-top-10" style="margin-left: 20px;margin-right: 20px">
        商品描述：<span>{{ productName }}</span>&nbsp;&nbsp;
      </p>
      <div class="flex-row" style="border: 1px solid #D1D2D3;  margin: 20px;">
        <div class="flex-column" style="flex-grow: 1;flex-shrink: 0;">
          <p class="modal-content-title fz-18 color-33 margin-top-20">体验码</p>
          <img :src="qrcodeUrl" alt=""
               style="width: 128px; height: 128px;margin: 10px">
          <div class="margin-top-20"><span class="fz-14" v-if="exportTime">{{ exportTime }}到期</span></div>
          <div class="margin-top-10" style="margin-bottom: 30px"><span class="fz-14 color-33">手机扫码体验</span></div>
        </div>
      </div>
    </Modal>

    <Modal
        @on-visible-change="onQrcodeModalClose"
        class-name="vertical-center-modal"
        footer-hide
        v-model="showBuyModel"
        width="550">
      <div class="flex-row" style="border: 1px solid #D1D2D3;  margin: 20px;">
        <div class="flex-column" style="width:90%;flex-shrink: 0;">
          <p class="modal-content-title fz-18 color-33 margin-top-20" style="word-break: break-all">
            商品描述：<span>{{ productName }}</span>&nbsp;&nbsp;
          </p>
          <img :src="qrcodeUrl" alt="" class=" margin-top-20"
               style="width: 120px; height: 120px;">
          <div class="margin-top-30"><span class="fz-14" v-if="exportTime">{{ exportTime }}到期</span></div>
          <div
              class="flex-row margin-top-10"
              style="margin-bottom: 30px;width: 143px;height:33px ;border-radius: 3px;border:1px solid #67B3FF;background-color:#E6F1FC ">
            <img alt="" src="../../../assets/common/ic_xiazai@2x.png" style="width:15px;height: 14px; ">
            <div @click="onQrcodeDownload" style="color:#1989FA;font-size: 14px;margin-left: 5px">立即下载</div>
          </div>
        </div>
      </div>
    </Modal>
    <!--    分享设置弹框-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose" class="modals"
           class-name="vertical-center-modal" footer-hide v-model="shareModal" width="550">
      <share-page-setting-widget :editData="editShareData" @cancel="shareModal=false"
                                 @config="onShareConfigOK"></share-page-setting-widget>
    </Modal>
  </base-page-component>

</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import UpLoadImage from '@/components/common/UpLoadImage'
import {mapActions} from 'vuex'
import ClassGroupSettingWidget from '../../../components/common/ClassGroupSettingWidget2'
import ClassChooseWidget from '../../../components/common/ClassChooseWidget'
import mixin from '../../../config/mixinfile'
import ClassVerticalChooseWidget from '../../../components/common/ClassVerticalChooseWidget'
import {handleSimpleDownload} from '../../../utils/filedown'
import SharePageSettingWidget from '../boot/component/SharePageSettingWidget'

export default {
  name: 'ProductList',
  mixins: [mixin.mixin],
  components: {
    SharePageSettingWidget,
    ClassVerticalChooseWidget,
    ClassChooseWidget,
    ClassGroupSettingWidget,
    BasePageComponent,
    UpLoadImage,
  },
  data () {
    return {
      title: '',
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: 'https://goodsmanual.laodao.co/goods/goodsCategory.html?contentType=33&id=0'
      },
      objData: {
        classId: 0,
        groupId: 0,
        init: false
      },
      editId: 0,
      tableHeight: 620,
      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 20,
      },
      objInfo: {
        classId: 0,
        className: '',
        groupId: 0,
        groupName: '',
        init: false
      },
      groupManager: {
        title: '分类管理',
        show: false,
      },

      shareModal: false,
      editPageId: 0,
      editShareData: {
        editPageId: 0,
        shareCover: '',
        shareTitle: '',
      },

      renameModal: {
        show: false,
        title: '重置名称',
        name: '',
        row: {},
      },
      createPageModal: {
        show: false,
        title: '新建商品',
        pageTitle: '',
      },
      columns: [
        {
          title: '商品分类',
          key: 'categoryName',
          width: 120,
          tooltip: true
        }, {
          title: '商品分组',
          key: 'groupName',
          width: 120,
          tooltip: true
        },
        {
          title: '商品名称',
          key: 'name',
          minWidth: 240,
          tooltip: true
        }, {
          title: '状态',
          key: 'isActive',
          slot: 'status',
          width: 100,
          align: 'center',
          // render: (h, params) => {
          //   return h('span', {
          //     style: {
          //       color: 'red'
          //     }
          //   }, params.row.status)
          // }
          // }, {
          //   title: '商品链接',
          //   key: 'url',
          //   minWidth: 460,
          //   align: 'center',
          //   tooltip: true,
          // }, {
          //   title: '复制',
          //   slot: 'copy',
          //   width: 80,
          //   align: 'center'
        }, {
          title: '操作',
          slot: 'operation',
          width: 340
        }
      ],
      dataList: [],

      showModel: false,
      showBuyModel: false,
      productName: '',
      qrcodeUrl: '',                         //选中商品老刀码
      exportTime: '',                        //过期时间
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
  },
  methods: {
    init () {
      this.setTableHeight()
      this.onGetGoods()
    },
    setTableHeight () {
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    onGetGoods () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.title) {
        params.name = this.title
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }

      this.getGoods(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.url = child.link ? child.link.link || '' : ''
            child.isActive = child.isEnable || 0
            return child
          })
          this.tablePage.total = res.data.total || 0
          if (res.data.pageNum > res.data.pages && res.data.pages > 0) {    //页码超了
            this.tablePage.currentPage = res.data.pages
            this.onGetGoods()
          }
        }
      })
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    getStatus (row) {
      if (row.isActive === 1) {
        return 'red'
      } else {
        return 'green'
      }
    },
    onPageRenovationClick (row) {
      const {href} = this.$router.resolve({
        path: '/productpage',
        query: {
          proId: row.id,
          tagTitle: row.name + '菜单'
        }
      })
      this.$router.push(href)
    },
    /**
     *商品案例装修
     * */
    onGoodsCaseClick (row) {
      const {href} = this.$router.resolve({
        path: '/goodscase',
        query: {
          proId: row.id
        }
      })
      this.$router.push(href)
    },
    onGoodsEdit (row) {
      this.editId = row.id
      this.objData = {
        classId: row.categoryId || 0,
        groupId: row.groupId || 0,
        init: true
      }
      this.createPageModal = {
        show: true,
        title: '编辑商品',
        pageTitle: row.name || '',
      }
    },
    createNewPage () {
      this.editId = 0
      this.objData = {
        classId: 0,
        groupId: 0,
        init: false
      }
      this.createPageModal = {
        show: true,
        title: '新建商品',
        pageTitle: '',
      }
    },
    createPageModalCancel () {
      this.editId = 0
      this.createPageModal.show = false
    },
    async createPageModalOk () {
      if (!this.createPageModal.pageTitle) {
        return this.$Message.info('请输入商品名称')
      }
      if (!this.objData.classId) {
        return this.$Message.info('请输入商品分类')
      }

      if (!this.objData.groupId) {
        return this.$Message.info('请输入商品分组')
      }

      let pageName = this.createPageModal.pageTitle
      if (this.editId) {
        let res = await this.editItemGood({
          id: this.editId,
          params: {
            name: pageName,
            groupId: this.objData.groupId || 0,
            categoryId: this.objData.classId || 0,
          }
        })
        if (res.code === 0) {
          this.onGetGoods()
          this.editId = 0
          this.createPageModal.show = false
        } else {
          if (res.msg) {
            this.$Message.info(res.msg)
          }
        }

      } else {
        let coverList = []
        let specList = []
        let goods = {
          groupId: this.objData.groupId || 0,
          categoryId: this.objData.classId || 0,
          coverList: coverList || [],
          code: '',
          name: this.createPageModal.pageTitle,
          title: this.createPageModal.pageTitle,
          generalName: '',
          desc: '',
          advertTitle: '',
          shelfLife: '',
          specList: specList,
          descList: [],
          customList: [],
          ingredientList: [],
          detailsList: []
        }

        let pageStyle = {
          pageBgColor: '#F9F9F9',
          navTitleColor: '#333333',
          navBgColor: 'white',
          logoWidth: 0,
          logoHeight: 0,
          pageBgImgWidth: 0,
          pageBgImgHeight: 0,
          widgetTopMargin: 5,
          widgetLrMargin: 0
        }

        let pageExtension = {
          showNav: 0,
          logo: '',
          pageBgImg: '',
          buttonUrl: '',
          showPrice: 0
        }
        let containerList = []

        let decorate = {
          rootContentId: 7,
          name: pageName,
          title: pageName,
          decorateMode: 1,
          jumpLink: '',
          style: JSON.stringify(pageStyle) || '',
          extension: JSON.stringify(pageExtension) || '',
          containerList: containerList || []
        }
        let params = {
          ...goods,
          page: decorate
        }
        let result = await this.addGoods(params)
        if (result.code === 0) {
          this.onGetGoods()
          this.editId = 0
          this.createPageModal.show = false
        } else {
          if (result.msg) {
            this.$Message.info(result.msg)
          }
        }
      }
    },

    onShareSettingClick (row, index) {                     //点击分享设置
      this.editShareData = {
        editPageId: row.page ? row.page.id : 0,
        shareCover: row.page ? row.page.shareCover || '' : '',
        shareTitle: row.page ? row.page.shareTitle || '' : ''
      }
      this.shareModal = true
    },

    onShareConfigOK () {
      this.onGetGoods()
      this.shareModal = false
    },
    onRenameClick (row) {                         //重置名称
      this.renameModal = {
        show: true,
        name: row.name,
        row: row,
      }
    },

    renameModalCancel () {                        //重置名称 确认
      this.renameModal.show = false
    },
    renameModalOk () {                            ////重置名称 取消
      if (!this.renameModal.name) {
        this.$Message.info('名称不能为空')
        return
      }
      this.renameModal.show = false
      this.renameModal.row.name = this.renameModal.name
    },
    //删除页面
    delPage (row, index) {
      const content = '<p>确定要删除商品 ' + row.name + ' 吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let params = {
            idList: row.id
          }
          this.delGood(params).then(res => {
            if (res.code === 0) {
              this.onGetGoods()
            }
          })
        },
        onCancel: () => {
        }
      })
    },

    //停用 发布页面
    changeStatus (row, index) {
      const operator = row.isActive === 1 ? '停用' : '发布'
      var page = row.name
      this.$Modal.confirm({
        title: '提示',
        content: '确定要' + operator + '商品 <span style="color:red">' + page + '</span> 吗?',
        onOk: () => {
          this.editItemGood({
            id: row.id,
            params: {
              isEnable: row.isActive === 1 ? 0 : 1
            }
          }).then(res => {
            if (res.code === 0) {
              this.onGetGoods()
            }
          })
        },
        onCancel: () => {
        }
      })
    },
    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      if (!this.objChange.linkurl) {
        this.objChange.linkurl = 'https://goodsmanual.laodao.co/goods/goodsCategory.html?contentType=33&id=0'
      }
      this.tablePage.currentPage = 1
      this.onGetGoods()
    },
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.onGetGoods()
    },
    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.onGetGoods()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.onGetGoods()
      }
    },
    onImageClick (item) {
      // if ((!item.qrcodeInfo) || (item.qrcodeInfo && (item.qrcodeInfo.purchaseStatus !== 1))) {
      //   return this.onShowQRCode(item)
      // }
      // if (item.qrcodeInfo && (item.qrcodeInfo.purchaseStatus === 1)) {
      return this.onShowBuyCode(item)
      // }
    },
    onShowQRCode (row) {
      this.productName = row.name
      this.qrcodeUrl = row.qrcodeInfo ? row.qrcodeInfo.qrcodeUrl || '' : ''
      this.exportTime = row.qrcodeInfo ? row.qrcodeInfo.effectEndTime || '' : ''
      this.showModel = true
    },
    onShowBuyCode (row) {
      this.productName = row.name
      // this.exportTime = row.qrcodeInfo ? row.qrcodeInfo.effectEndTime || '' : ''
      // this.qrcodeUrl = row.qrcodeInfo ? row.qrcodeInfo.qrcodeUrl || '' : ''
      this.qrcodeUrl = row.qrcodeUrl || ''
      if (this.qrcodeUrl) {
        this.showBuyModel = true
      }
    },
    onQrcodeDownload () {
      if (this.qrcodeUrl) {
        handleSimpleDownload(this.qrcodeUrl)
      }
    },
    onQrcodeModalClose (status) {
      if (!status) {
        this.productName = ''
        this.exportTime = ''
        this.qrcodeUrl = ''
      }
    },
    onModalClose (status) {
      if (!status) {
        this.editPageId = 0
        this.editShareData = {
          editPageId: 0,
          shareCover: '',
          shareTitle: '',
        }
      }
    },
    onPageModalClose (status) {
      if (!status) {
        this.objData = {
          classId: 0,
          groupId: 0,
          init: false
        }
        this.editId = 0
      }
    },
    ...mapActions([
      'getGoods',
      'addGoods',
      'delGood',
      'shelfgoods',
      'editItemGood'
    ])
  }
}
</script>

<style lang="scss" scoped>
.modal-setting ::v-deep {

  .ivu-modal-body {
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
  }

  //标题下横线
  .ivu-modal-header {
    border-bottom: none;
  }

  //确认取消按钮上面红线
  .ivu-modal-footer {
    border-top: none;
  }
}
</style>
<style scoped>
.modals >>> .ivu-modal-body {
  padding: 0;
}

.tablePtye >>> .ivu-table-cell {
  padding-left: 5px;
  padding-right: 5px;
}

/*.modals >>> .ivu-modal-content {*/
/*border-bottom-left-radius: 0px;*/
/*border-bottom-right-radius: 0px;*/
/*}*/
</style>
